module.exports = __webpack_public_path__ + "img/akfel-wgc-paris-multitouch-application-15.30fbfb3c.jpg";